<script lang="ts">
	// InputControl is a wrapper around exactly one input element
	// that adds a consistent label style and validation behavior.
	import { onMount } from 'svelte';

	let className = '';
	export { className as class };

	export let label = '';
	export let label2 = '';
	export let sublabel = '';
	export let caption = '';
	export let nopad = false;
	export let error: string | string[] = '';

	let thisEl: HTMLElement;

	onMount(() => {
		//const els = thisEl.querySelectorAll('input,textarea,select');
		//if (els.length > 1) throw new Error('InputControl can only have one input element');
		//if (els.length === 0) throw new Error('InputControl must have an input or textarea element');
	});
</script>

<label class={['form-control', className].join(' ')} bind:this={thisEl}>
	{#if label}
		<div class="label">
			<div class="flex flex-col">
				<span class="label-text">{label}</span>
				{#if sublabel}<span class="text-xs opacity-50">{sublabel}</span>{/if}
			</div>
			{#if label2}
				<span class="label-text-alt">{label2}</span>
			{/if}
		</div>
	{/if}
	<slot />
	{#if caption}<p class="mt-2 text-xs opacity-50">{caption}</p>{/if}
	{#if !nopad || !error}
		<div class="label">
			{#if error}
				<span class="label-text text-error">{error}</span>
			{/if}
		</div>
	{/if}
</label>
